function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.61968 2H34.3184C35.2471 2 36 2.75289 36 3.68163V26.7796C36 27.3617 35.6989 27.9025 35.204 28.2091L19.8546 37.7184C19.3121 38.0545 18.626 38.0545 18.0834 37.7184L2.73405 28.2091C2.23916 27.9025 1.93805 27.3617 1.93805 26.7796V3.68163C1.93805 2.75289 2.69094 2 3.61968 2Z",
  stroke: "#4C5B6B",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7578 10L10.7578 22.4058L15.7079 22.3763V18.1034H19.5652L22.8683 22.3726H27.6199L24.1919 17.9422C26.8215 17.3897 27.8158 15.5724 27.8158 14.0188C27.8158 12.1049 27.0508 10 22.0901 10L10.7578 10ZM15.6925 12.7737H21.7881C21.7881 12.7737 22.9908 12.7737 22.9908 13.9571C22.9908 15.1406 21.7881 15.2334 21.7881 15.2334H15.6925V12.7737Z",
  fill: "#4C5B6B"
});

var SvgStatusEmpty = function SvgStatusEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStatusEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status_empty.e3de26a2.svg";
export { ForwardRef as ReactComponent };